import { render, staticRenderFns } from "./leavetype.vue?vue&type=template&id=26e4ecda&"
import script from "./leavetype.vue?vue&type=script&lang=js&"
export * from "./leavetype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports